import { render, staticRenderFns } from "./lga.vue?vue&type=template&id=d1407192&"
import script from "./lga.vue?vue&type=script&lang=js&"
export * from "./lga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports